import formats from '../../api/formats'
import AssistClasses from '../assist/AssistClasses.js'
import DocAbstract from './DocAbstract.js'

class Strategy extends DocAbstract.Strategy {
  getTypeCode () {
    return 'PENSION_CERT_RF'
  }
  getTypeName () {
    return 'Страховое свидетельство государственного пенсионного страхования'
  }
  createModel () {
    var model = new Model()
    return model
  }
  createDefaultModel (individual) {
    return Object.assign(this.createModel(),
      {
        surname: individual.lastName,
        firstname: individual.firstName,
        patronymic: individual.middleName,
        sex: individual.sex,
        birthday: individual.birthday,
        snils: individual.snils
      })
  }
  updateSteps (scheme) {
    const ruleSnils = (v) => !v || formats.isSnils(v) || 'Неверный формат СНИЛС'
    const ruleNameRu = (v) => !v || formats.isNameRu(v, 60) || 'Допустимы русские буквы'
    let steps = []

    new AssistClasses.Step(
      '',
      (step) => {},
      {
        scheme: [
          {
            fieldType: 'v-text-field',
            label: 'Страховой номер',
            name: 'snils',
            rules: Array.of(ruleSnils),
            grow: true,
            size: {sm8: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Фамилия',
            name: 'surname',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Имя',
            name: 'firstname',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Отчество',
            name: 'patronymic',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs6: true}
          },
          {
            fieldType: 'v-select',
            label: 'Пол',
            name: 'sex',
            itemText: 'text',
            itemValue: 'value',
            items: [
              {value: 'F', text: 'Жен.'},
              {value: 'M', text: 'Муж.'}
            ],
            grow: true,
            size: {sm6: true, xs6: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Дата рождения',
            name: 'birthday',
            grow: true,
            size: {sm6: true, xs8: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Место рождения',
            name: 'birthplace',
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Дата регистрации',
            name: 'registered',
            grow: true,
            size: {sm6: true, xs8: true}
          }
        ]
      },
      {
      }).addToArray(steps)

    this.steps = steps
    return this
  }
  viewNumber (model) {
    return `${model['snils'] ? model['snils'] : '-'}`
  }
  viewTitleComp (model) {
    return formats.createComp(`
      <span>${this.getTypeName()}</span>
    `)
  }
  viewContentComp (model) {
    return formats.createComp(`
      <div>
      <div>Страховой номер:<b> ${model['snils'] ? model['snils'] : '-'}</b></div>
      <div>Дата регистрации:<b> ${model['registered'] ? formats.formatDate(model['registered']) : '-'}</b></div>
      </div>`)
  }
}

class Model {
  constructor () {
    this.modelType = '101.01'
  }
}

function createStrategy (cxt) {
  return new Strategy(cxt)
}

export default {
  createStrategy,
  Model
}



// WEBPACK FOOTER //
// ./src/components/people/DocPensionCertRF.js